module.exports = __webpack_public_path__ + "static/Gapsi-a75095530e55350e5e675cdb531c2dbf.png";